import {
    newProductPlanTypes,
    CreateNewProductPlanPayload,
    UpdateNewProductPlanPayload,
    NewProductPlanFilters,
} from "redux/Ldb/types/newProductPlanTypes";
import { newProductPlanService } from "services/Ldb/newProductPlanService";
import { Dispatch } from "redux";

export const newProductPlanActions = {
    fetchSingleNewProductPlan,
    fetchNewProductPlans,
    createNewProductPlan,
    updateNewProductPlan,
    pinNewProductPlan,
    unpinNewProductPlan,
    cancelNewProductPlan,
    deleteNewProductPlan,
    resetFetchSingleNewProductPlan,
    resetFetchNewProductPlans,
    resetCreateNewProductPlan,
    resetUpdateNewProductPlan,
    resetPinNewProductPlan,
    resetUnpinNewProductPlan,
    resetCancelNewProductPlan,
    resetDeleteNewProductPlan,
    request,
    success,
    failure,
};

function fetchSingleNewProductPlan(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.FETCH_SINGLE_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.getSingleNewProductPlan(id);
            dispatch(success(newProductPlanTypes.FETCH_SINGLE_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.FETCH_SINGLE_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function fetchNewProductPlans(filters: NewProductPlanFilters) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.FETCH_NEW_PRODUCT_PLANS_REQUEST));
        try {
            const response = await newProductPlanService.getNewProductPlans(filters);
            dispatch(success(newProductPlanTypes.FETCH_NEW_PRODUCT_PLANS_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.FETCH_NEW_PRODUCT_PLANS_FAILURE, error));
        }
    };
}

function createNewProductPlan(data: CreateNewProductPlanPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.CREATE_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.createNewProductPlan(data);
            dispatch(success(newProductPlanTypes.CREATE_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.CREATE_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function updateNewProductPlan(data: UpdateNewProductPlanPayload) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.UPDATE_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.updateNewProductPlan(data);
            dispatch(success(newProductPlanTypes.UPDATE_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.UPDATE_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function pinNewProductPlan(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.PIN_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.pinNewProductPlan(id);
            dispatch(success(newProductPlanTypes.PIN_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.PIN_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function unpinNewProductPlan(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.UNPIN_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.unpinNewProductPlan(id);
            dispatch(success(newProductPlanTypes.UNPIN_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.UNPIN_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function cancelNewProductPlan(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.CANCEL_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.cancelNewProductPlan(id);
            dispatch(success(newProductPlanTypes.CANCEL_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.CANCEL_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function deleteNewProductPlan(id: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(newProductPlanTypes.DELETE_NEW_PRODUCT_PLAN_REQUEST));
        try {
            const response = await newProductPlanService.deleteNewProductPlan(id);
            dispatch(success(newProductPlanTypes.DELETE_NEW_PRODUCT_PLAN_SUCCESS, response));
        } catch (error) {
            dispatch(failure(newProductPlanTypes.DELETE_NEW_PRODUCT_PLAN_FAILURE, error));
        }
    };
}

function resetFetchSingleNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_FETCH_SINGLE_NEW_PRODUCT_PLAN });
    };
}

function resetFetchNewProductPlans() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_FETCH_NEW_PRODUCT_PLANS });
    };
}

function resetCreateNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_CREATE_NEW_PRODUCT_PLAN });
    };
}

function resetUpdateNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_UPDATE_NEW_PRODUCT_PLAN });
    };
}

function resetPinNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_PIN_NEW_PRODUCT_PLAN });
    };
}

function resetUnpinNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_UNPIN_NEW_PRODUCT_PLAN });
    };
}

function resetCancelNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_CANCEL_NEW_PRODUCT_PLAN });
    };
}

function resetDeleteNewProductPlan() {
    return (dispatch: Dispatch) => {
        dispatch({ type: newProductPlanTypes.RESET_DELETE_NEW_PRODUCT_PLAN });
    };
}

function request(type: string) {
    return { type };
}

function success(type: string, data?: any) {
    return { type, payload: data };
}

function failure(type: string, error?: any) {
    return { type, payload: error };
}
